import EntityCrudPage from '../../shared/EntityCrudPage';
import { regulationConfig } from '../../config/entityConfigs';

const RegulationsPage = () => <EntityCrudPage config={regulationConfig} />;

export default RegulationsPage;
